module.exports = __webpack_public_path__ + "static/media/22ESCWA14.08b24dbc.jpg";